import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RoutePaths from '../routes/RoutePaths';
import {
    Stack,
    Box,
    Typography,
    Card,
    CardContent,
    Divider,
    Skeleton,
    Tooltip,
} from '@mui/material';
import { FormattedDate, FormattedMessage } from 'react-intl';
import Markdown from 'react-markdown';
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';

const DEBUG = false;

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});

const SearchItem = ({
    id,
    title,
    date,
    query,
    filters,
    clickAction
}) => {
    if (DEBUG) console.log("SearchHistory :: SearchItem :: Render :: ", title, date, query, filters);
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                minWidth: 275,
                cursor: "pointer",
            }}
            onClick={() => {
                if (id) {
                    if (clickAction) {
                        clickAction();
                    }
                    navigate(
                        `${RoutePaths.root.search}/${id}`);
                }
            }}
        >
            <Card variant="outlined">
                <CardContent>
                    {
                        (title || date) &&
                        <Typography
                            gutterBottom
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                fontSize: 14
                            }}>
                            {title} <FormattedDate value={date} />
                        </Typography>
                    } {
                        title &&
                        <Typography variant="subtitle2" component="div">
                            <Markdown>{title}</Markdown>
                        </Typography>
                    } {
                        <Typography variant="body2" sx={{ mb: 0 }}>
                            {query}
                        </Typography>
                    } {
                        filters && filters.length > 0 &&
                        <Stack
                            direction="row"
                            spacing={1}
                            align="start"
                            width="100%"
                            mt={1}>
                            {
                                filters.map((filter, index) => {
                                    //if (filter.type === "text" || filter.type === "dropDown") {
                                    return (
                                        <Tooltip
                                            key={index}
                                            title={<FormattedMessage
                                                id={`filterType.${filter.name}`} />}
                                            placement="bottom">
                                            <StyledBreadcrumb
                                                key={index}
                                                component="a"
                                                label={
                                                    filter.value instanceof Array ?
                                                        filter.value.join(", ") :
                                                        filter.value
                                                }
                                            />
                                        </Tooltip>
                                    );
                                    //} else {
                                    //    return null;
                                    //}
                                })
                            }
                        </Stack>
                    }
                    {
                        /*
                        false &&
                        <Typography variant="body2">
                            {summary}
                    </Typography>
                    */
                    }
                </CardContent>
            </Card>
        </Box>
    );
}

const SearchHistory = ({ searchesQuery, clickAction }) => {
    return (
        <Stack direction="column" spacing={2} align="start" width="100%">
            {
                searchesQuery.isLoading &&
                <>
                    {[...Array(3)].map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="rectangular"
                            width="100%"
                            height={85} />
                    ))}
                </>
            }
            {
                searchesQuery.isError &&
                <span>Virhe</span>
            }
            {
                searchesQuery.data &&
                searchesQuery.data.result &&
                searchesQuery.data.result.length > 0 &&
                searchesQuery.data.result
                    .sort((a, b) => { return new Date(b.timestamp) - new Date(a.timestamp) })
                    .map((search) => (
                        <SearchItem
                            id={search.id}
                            key={search.id}
                            date={search.timestamp}
                            query={search.query}
                            filters={search.filters}
                            clickAction={clickAction}
                        />
                    ))
            }
            {
                searchesQuery.data &&
                searchesQuery.data.result &&
                searchesQuery.data.result.length === 0 &&
                <FormattedMessage id="search.history.empty" />
            }
        </Stack>
    );
}

export default SearchHistory;